import { Review } from 'schema-dts';
import { Product, UserReview } from 'src/types';
import { TranslateFunc } from 'src/components/translate';
import { rating } from './rating';

export function reviews(product: Product, t: TranslateFunc): Review[] {
  return product
    .userReviews!.nodes.filter(r => r !== undefined && r !== null)
    .map(item => review(item as UserReview, t));
}

export function review(item: UserReview, t: TranslateFunc): Review {
  // @NOTE: Do not include "reviewBody: item.reviewText," (potential XSS).
  return {
    '@type': 'Review',
    datePublished: item.updatedAt || undefined,
    reviewRating: rating(item.rating),
    author: {
      '@type': 'Person',
      // @NOTE: This assumes display names are validated (!)
      name: item.user?.name ?? t('reviews', 'user.guest'),
    },
  };
}
